


















import { Component, Prop, Vue } from 'vue-property-decorator';
import ReportSearchForm from '@/components/report/search/Form.vue';

@Component({
  name: 'ReportSearch',
  components: {
    ReportSearchForm,
  },
})
export default class extends Vue {
  get showResult() {
    return this.$route.name === 'report-search-result';
  }
}
